import { createSlice } from '@reduxjs/toolkit'
import authservice from '../../services/authservice';

const initialState = {
    user: authservice.getUserInfo(),
    accessToken: authservice.getAccessToken(),
    isLoggedIn: authservice.withAccessToken(),
    loading: false,
    error: null,
    navigatePath: '',
    modules: JSON.parse(localStorage.getItem("allowedModules") || "[]"),
    userProfile:{
        requesting: false,
        error: null,
        success: false,
        data: null
    },
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
        state.loading = true;
        state.error = null;
    },
    loginSuccess: (state, action) => {
        state.loading = false;
        state.isLoggedIn = true;
        state.accessToken = action.payload;
        state.error = null;
    },
    loginFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    logoutRequest: (state) => {
        state.loading = true;
        state.error = null;
    },
    logoutSuccess: (state) => {
        state.loading = false;
        state.isLoggedIn = false;
        state.user = null;
        state.accessToken = null;
        state.error = null;
    },
    logoutFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    getAuthUser: (state) => {
        state.loading = true;
        state.error = null;
    },
    getAuthUserSuccess: (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
    },
    getAuthUserFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    getAuthUserModule: (state) => {
        state.loading = true;
        state.error = null;
    },
    getAuthUserModuleSuccess: (state, action) => {
        state.loading = false;
        localStorage.setItem("allowedModules", JSON.stringify(action.payload));
        state.modules = action.payload;
        state.error = null;
    },
    getAuthUserModuleFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    navigateTo: (state, action) => {
        state.navigatePath = action.payload;
    },
    getUserProfile: (state) => {
        state.userProfile.requesting = true;
        state.userProfile.error = null;
        state.userProfile.data = null;
        state.userProfile.success = false;
    },
    getUserProfileSuccess: (state, action) => {
        state.userProfile.requesting = false;
        state.userProfile.data = action.payload;
        state.userProfile.success = true;
    },
    getUserProfileFail: (state, action) => {
        state.userProfile.requesting = false;
        state.userProfile.error = action.payload;
    },
    doChangePassword: (state) => {
        state.loading = true;
        state.error = null;
    },
    doChangePasswordSuccess: (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.error = null;
    },
    doChangePasswordFail: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
  },
})

export const { 
    loginRequest, loginSuccess, loginFail,
    logoutRequest, logoutSuccess, logoutFail,
    getAuthUser, getAuthUserSuccess, getAuthUserFail,
    getAuthUserModule, getAuthUserModuleSuccess, getAuthUserModuleFail,
    navigateTo,
    getUserProfile, getUserProfileSuccess, getUserProfileFail,
    doChangePassword, doChangePasswordSuccess, doChangePasswordFail
} = authSlice.actions

export default authSlice.reducer